export default __webpack_public_path__ + "static/media/BlackSlantBackward.0f80db11.svg";